import React from 'react';
import PropTypes from 'prop-types';
import { Alert as RBAlert } from 'react-bootstrap';
import classNames from 'classnames';

import styles from './Alert.module.scss';

const VARIANT = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  SUCCESS: 'success',
  DANGER: 'danger',
  WARNING: 'warning',
  INFO: 'info',
  LIGHT: 'light',
  DARK: 'dark',
  DOTTED: 'dotted',
};

const Alert = ({
  closeLabel,
  dismissable,
  onClose,
  show,
  transition,
  variant,
  bsPrefix,
  className,
  style,
  children,
}) => {
  return (
    <RBAlert
      closeLabel={closeLabel}
      dismissible={dismissable}
      onClose={onClose}
      show={show}
      transition={transition}
      variant={variant}
      bsPrefix={bsPrefix}
      className={classNames(className, {
        [styles.dotted]: variant === VARIANT.DOTTED,
      })}
      style={style}
    >
      {children}
    </RBAlert>
  );
};

Alert.propTypes = {
  closeLabel: PropTypes.string,
  dismissable: PropTypes.bool,
  onClose: PropTypes.func,
  show: PropTypes.bool,
  transition: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.elementType,
  ]),
  variant: PropTypes.oneOf(Object.values(VARIANT)),
  bsPrefix: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};

export default Alert;
